import * as React from 'react'
import { LucideIcon, Loader2 } from 'lucide-react'
import { getIcon, Icons } from '@/config/icons.map'
import { cn } from '@/lib/utils'

/** Icon names from registry + 'loader'. Use registry names (e.g. from API) or add to icons.map.ts */
export type IconName = keyof typeof Icons | 'loader' | string

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  name: IconName
  size?: number | string
  className?: string
}

// Verify Icons registry is loaded at module initialization
if (typeof window !== 'undefined' && import.meta.env.DEV) {
  if (!Icons || Object.keys(Icons).length === 0) {
  }
}

const Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ name, size = 20, className, ...props }, ref) => {
    if (name === 'loader') {
      return (
        <Loader2
          ref={ref}
          size={size}
          className={cn('animate-spin', className)}
          {...props}
        />
      )
    }

    let IconComponent: LucideIcon
    try {
      IconComponent = getIcon(name)
    } catch (error) {
      if (import.meta.env.DEV) {
        console.warn(`[Icon] Unknown icon "${String(name)}"`, error)
      }
      return (
        <span
          ref={ref as React.Ref<HTMLSpanElement>}
          className={cn('inline-block shrink-0', className)}
          style={{ width: size, height: size }}
          aria-hidden
          data-unknown-icon={String(name)}
        />
      )
    }

    return (
      <IconComponent
        ref={ref}
        size={size}
        className={className}
        {...props}
      />
    )
  }
)
Icon.displayName = 'Icon'

export { Icon }

